export default __webpack_public_path__ + "static/media/img_04.9648f739.jpg";